import React, { useContext, useState } from "react";
import { Trans, withTranslation } from "react-i18next";
import "./SubstituteSelector.scss";
import SubstituteSelectorContext from "./SubstituteSelectorContext";
import RadioGroup from "./RadioGroup";
import RadioOption from "./RadioOption";
import ActionButtonGroup from "./ActionButtonGroup";

const OwnershipSelectionStep = ({
  removeFromSingleOffice,
  substitutes,
  onConfirm,
  t,
}) => {
  const { onCancel, isActionExecuting } = useContext(SubstituteSelectorContext);
  const [selectedSubstituteId, setSelectedSubstituteId] = useState(0);
  const [selectedOwnership, setSelectedOwnership] = useState(1);

  const ownershipOptions = [
    { value: 1, label: t("accountOwner.ownershipSelectionOption1") },
    {
      value: 2,
      label: t("accountOwner.ownershipSelectionOption2", {
        count: removeFromSingleOffice ? 1 : 2,
      }),
    },
  ];

  const isConfirmDisabled =
    (selectedOwnership === 2 && selectedSubstituteId === 0) || isActionExecuting;

  const handleConfirm = () => {
    onConfirm(selectedSubstituteId === 0 ? null : selectedSubstituteId);
  };

  return (
    <div>
      <p className="sss-description">
        <Trans i18nKey="accountOwner.ownershipSelectionDescription">
          This person is an '<strong>Account Admin</strong>' for this office.
          There are work items such as Tasks created by this person that should
          be transferred to another Admin in your account.
        </Trans>
      </p>

      <RadioGroup
        name="ownershipSelection"
        selectedValue={selectedOwnership}
        onSelectionChange={setSelectedOwnership}
        options={ownershipOptions}
      />

      {selectedOwnership === 2 && (
        <SubstituteList
          substitutes={substitutes}
          selectedSubstituteId={selectedSubstituteId}
          onSelectionChange={setSelectedSubstituteId}
        />
      )}

      <ActionButtonGroup
        primaryButtonKey="confirm"
        onPrimaryClick={handleConfirm}
        onCancel={onCancel}
        isLoading={isActionExecuting}
        isDisabled={isConfirmDisabled}
      />
    </div>
  );
};

const SubstituteList = ({
  substitutes,
  selectedSubstituteId,
  onSelectionChange,
}) => {
  if (substitutes.length === 0) {
    return (
      <p className="oss-info-text">
        <strong>Info:</strong> You need to have another Admin for this office to
        select this option.
      </p>
    );
  }

  return (
    <>
      <hr />
      <div>
        <p style={{ fontSize: "13px" }}>Select Account Admin</p>
        <div className="sss-radio-group">
          {substitutes.map((substitute) => (
            <RadioOption
              key={substitute.id}
              name="substituteSelection"
              value={substitute.id}
              checkedValue={selectedSubstituteId}
              onChange={onSelectionChange}
            >
              {`${substitute.firstName} ${substitute.lastName}`}
            </RadioOption>
          ))}
        </div>
      </div>
    </>
  );
};

export default withTranslation()(OwnershipSelectionStep);
